import { useState, useEffect } from "react";
import { 
    Box, 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    TextField, 
    Button, 
    Grid, 
    AppBar, 
    Tabs, 
    Tab, 
    useTheme, 
    Typography, 
    DialogContent 
} from "@material-ui/core"
import PostAddIcon from '@material-ui/icons/PostAdd'
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { 
    crearTerrestreAction,
    obtenerCatalogoProveedorTerrestre, 
    openMoadalAltaCiurcuito 
} from "./../../../ducks/proveedorTerrestreDuck"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import { DialogMessage } from "../../../global/DialogMessage";
import Swal from "sweetalert2";
import { formatDinero } from "../../../utils/formatDinero";
import ItinerarioForm from "../ItinerarioForm/ItinerarioForm";
import ExtrasCheckboxes, { convertExtrasToHTML, normalizarExtras } from "../../ProveedoresVuelos/ExtrasCheckboxes/ExtrasCheckboxes";
import { FProveedoresTerrestresStyle } from "./styles";
import useCatalogos from "../../../hooks/useCatalogos";
import AditamentosCustom from "../../ProveedoresVuelos/FAditamentosCustom/FAditamentosCustom";
import { obetenerPaqueteMayoristaListaDetalle } from "../../../ducks/proveedorMayoristaDuck";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            style={{ display: value === index ? "block" : "none" }}
            {...other}
        >
            <Box p={3}>
                {children}
            </Box>
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useCatalogoPrveedoresTerrestres = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCatalogoProveedorTerrestre()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Es requerido"),
    nombrePaquete: yup
        .string("Ingrese nombre de paquete")
        .required("Es requerido"),
})

const initialValues = {
    monto: 0,
    nombrePaquete: "",
}

const FProveedoresTerrestres = () => {
    const theme = useTheme()
    const dispatch = useDispatch()
    const classes = FProveedoresTerrestresStyle()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const catalogoTerrestreIncluye = useCatalogos("Package/Includes")
    
    const [value, setValue] = useState(0)
    const [open, setOpen] = useState(false)
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const [idProveedor, setIdProveedor] = useState(0)
    const [itinerario, setItenerario] = useState('<p><strong>Escribe aqui el itinerario</strong></p>')
    const [incluye, setIncluye] = useState('<p><strong>Escribe aqui lo que incluye</strong></p>')
    const [noIncluye, setNoIncluye] = useState('<p><strong>Escribe aqui lo que No Incluye</strong></p>')
    const [selectedExtrasIds, setSelectedExtrasIds] = useState([1,2,3,4,5,6,7]);
    const [customAditamentos, setCustomAditamentos] = useState([])

    const { catalogoTerrestre } = useSelector(store => store.proveedorTerrestre)

    const normalizedExtras = normalizarExtras(catalogoTerrestreIncluye);
    
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })
    
    useCatalogoPrveedoresTerrestres()
    
    useEffect(() => {
        if (formik.values.fechaInicio && formik.values.fechaFin) {
            const start = new Date(formik.values.fechaInicio);
            const end = new Date(formik.values.fechaFin);
            if (start < end) {
                const diffTime = Math.abs(end - start);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                formik.setFieldValue("dias", diffDays);
            }

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.fechaInicio, formik.values.fechaFin]);

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    const onItinerarioValue = (value) => {
        setItenerario(value)
    }    
    const handleSelecProveedor = (event) => {
        setIdProveedor(event.target.value)
    }
    const onClick = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
        setTipoMoneda(0)
        setValue(0)
        setItenerario('<p><strong>Escribe aqui el itinerario</strong></p>')
        setIncluye('<p><strong>Escribe aqui lo que incluye</strong></p>')
        setNoIncluye('<p><strong>Escribe aqui lo que No Incluye</strong></p>')
        formik.resetForm(initialValues)

        setSelectedExtrasIds([1,2,3,4,5,6,7,8]);
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }

    const handleAddCustomAditamento = (nuevoAditamento) => {
        const nuevoId = Math.max(0, ...customAditamentos.map(a => a.id)) + 1;
        setCustomAditamentos([
        ...customAditamentos, 
        {
            id: nuevoId,
            nombre: nuevoAditamento.nombre || nuevoAditamento,
            incluido: nuevoAditamento.incluido || false
        }
        ]);
    };
    const handleRemoveCustomAditamento = (id) => {
        setCustomAditamentos(customAditamentos.filter(a => a.id !== id));
    };
    
    const handleToggleCustomAditamento = (id) => {
        setCustomAditamentos(customAditamentos.map(aditamento => 
        aditamento.id === id 
            ? { ...aditamento, incluido: !aditamento.incluido } 
            : aditamento
        ));
    };

      const contarDiasItinerario = (htmlContent) => {
        if (!htmlContent) return 0;
        
        // Busca patrones como "Día X", "Dia X", "Day X", etc.
        const regex = /(d[ií]a|day)\s*\d+/gi;
        const matches = htmlContent.match(regex);
        
        return matches ? matches.length : 0;
    };

    const onSave = (values) => {
        if (tipoMoneda === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una moneda valida",
            })
            return null
        }
        if (idProveedor === 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una proveedor valido",
            })
            return null
        }

        const currentcyMoneda = catalogoMoneda.find(item => item.IdMoneda === tipoMoneda)
        const proveedorSeleccionado = catalogoTerrestre.find(prov => prov.IdProveedor === idProveedor);

         // Transformar customAditamentos al formato requerido
        const aditamentosCustomFormateados = customAditamentos.map(aditamento => ({
            Aditamento: aditamento.nombre,
            Incluye: aditamento.incluido
        }));

        const diasItinerario = contarDiasItinerario(itinerario);
        const aditamentosGeneralesIncluidos = selectedExtrasIds.length;
        const aditamentosGeneralesTotal = normalizedExtras.length;
        const aditamentosCustomIncluidos = customAditamentos.filter(a => a.incluido).length;
        const aditamentosCustomNoIncluidos = customAditamentos.length - aditamentosCustomIncluidos;
        
        DialogMessage.fire({
            title: '¿Estas seguro de crear este terrestre?',
            html: `<div>
                <ul class="custom-list" style="padding: 0; list-style: none;">
                    <li style="margin-bottom: 0.5rem;">
                        <strong>Proveedor</strong>: ${proveedorSeleccionado?.RazonSocial || 'No seleccionado'}
                    </li>
                    <li style="margin-bottom: 0.5rem;">
                        <strong>Nombre</strong>: ${values?.nombrePaquete}
                    </li>
                    <li style="margin-bottom: 0.5rem;">
                        <strong>Monto</strong>: ${formatDinero(values?.monto)} ${currentcyMoneda?.Clave}
                    </li>
                    <li style="margin-bottom: 0.5rem;">
                        <strong>Itinerario</strong>: Se configuraron ${diasItinerario} días
                    </li>
                </ul>
                
                <div style="margin-top: 1rem;">
                    <strong>Aditamentos:</strong>
                    <ul style="padding-left: 20px; margin-top: 0.5rem;">
                        <li>Generales: ${aditamentosGeneralesIncluidos} incluidos (de ${aditamentosGeneralesTotal})</li>
                        <li>Personalizados: ${aditamentosCustomIncluidos} incluidos, ${aditamentosCustomNoIncluidos} no incluidos</li>
                    </ul>
                </div>
            </div>`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: '¡Crear y continuar!',
            cancelButtonText: '¡Cancelar!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: '' }))
                dispatch(crearTerrestreAction({
                    ClavePaquete: "No aplica",
                    IdMoneda: tipoMoneda,
                    IdProveedor: idProveedor,
                    Itinerario: itinerario,
                    Nombre: values?.nombrePaquete,
                    PrecioNeto: values?.monto,
                    Incluye: incluye,
                    NoIncluye: noIncluye,
                    lCatIncluye: selectedExtrasIds,
                    lPaqueteAditamentoCustom: aditamentosCustomFormateados
                })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(obetenerPaqueteMayoristaListaDetalle())
                    dispatch(openMoadalAltaCiurcuito({
                        proveedor: {
                            idProveedor: Response,
                            claveProveedor: values?.clavePaquete,
                        }
                    }))
                    handleClose()
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                ToastMessage.fire(
                    'Cancelado',
                    'No se ha realizado ningun cambio',
                    'info'
                )
            }
        })
    }

    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onClick} endIcon={<PostAddIcon />}>
                Nuevo terrestre
            </Button>

            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Nuevo terrestre`}
                />

                <form onSubmit={formik.handleSubmit}>
                    <DialogContent dividers style={{height: "70vh", maxHeight: '600px', overflowY: 'scroll'}}>
                        <Grid container className={classes.containerSpacing}>
                            <Grid item xs={3}>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <InputLabel id="lTipoProveedor">Proveedor terrestre</InputLabel>
                                    <Select
                                        labelId="lTipoProveedor"
                                        id="STipoProveedor"
                                        name="proveedor"
                                        value={idProveedor}
                                        onChange={handleSelecProveedor}
                                        label="Proveedor terrestre"
                                    >
                                        <MenuItem value="0" disabled>
                                            {"Seleccione una opción"}
                                        </MenuItem>
                                        {catalogoTerrestre.map((item, index) => (
                                            <MenuItem key={item.IdProveedor} value={item.IdProveedor}>
                                                {item.RazonSocial}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    required
                                    id="input-Nombre"
                                    label="Nombre del terrestre"
                                    type="text"
                                    variant="outlined"
                                    name="nombrePaquete"
                                    value={formik.values.nombrePaquete}
                                    onChange={formik.handleChange}
                                    error={formik.touched.nombrePaquete && Boolean(formik.errors.nombrePaquete)}
                                    helperText={formik.touched.nombrePaquete && formik.errors.nombrePaquete}
                                    className={classes.textField}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    required
                                    id="input-Monto"
                                    label="Monto fijo"
                                    type="text"
                                    variant="outlined"
                                    name="monto"
                                    value={formik.values.monto}
                                    onChange={formik.handleChange}
                                    error={formik.touched.monto && Boolean(formik.errors.monto)}
                                    helperText={formik.touched.monto && formik.errors.monto}
                                    className={classes.textField}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl variant="outlined" className={classes.formControl}>
                                    <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                    <Select
                                        labelId="lTipoMoneda"
                                        id="STipoMoneda"
                                        name="tipoMoneda"
                                        value={tipoMoneda}
                                        onChange={handleSelecTipoMoneda}
                                        label="Moneda"
                                    >
                                        <MenuItem value="0" disabled>
                                            {"Seleccione una opción"}
                                        </MenuItem>
                                        {catalogoMoneda.map((moneda, index) => (
                                            <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                                {`${moneda.Clave} - ${moneda.Descripcion}`}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container className={classes.containerSpacing} >
                            <AppBar position="static">
                                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                                    <Tab label="Itinerario" {...a11yProps(0)} />
                                    <Tab label="Incluye / No Incluye" {...a11yProps(1)} />
                                    {/* <Tab label="No Incluye" {...a11yProps(2)} /> */}
                                </Tabs>
                            </AppBar>
                            <TabPanel 
                                value={value} 
                                index={0} 
                                keepMounted 
                                style={{ maxWidth: "720px", width: "100%", display: `${value === 0 ? "" : "none"}` }} 
                            >
                                <ItinerarioForm onChange={onItinerarioValue} />
                            </TabPanel>
                            <TabPanel value={value} index={1} keepMounted>
                                <Box style={{
                                    height: "400px",
                                    maxHeight: "50vh",
                                    overflowY: "auto",
                                    padding: "1rem",
                                    border: `1px solid ${theme.palette.primary.main}`,
                                }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" gutterBottom style={{ marginBottom: '1rem' }}>
                                                <strong>Aditamentos generales del paquete</strong>
                                            </Typography>
                                            <ExtrasCheckboxes
                                                extrasList={normalizedExtras}
                                                selectedIds={selectedExtrasIds}
                                                onSelectionChange={(newIds) => {
                                                    setSelectedExtrasIds(newIds);
                                                    setIncluye(convertExtrasToHTML(newIds, normalizedExtras, true));
                                                    setNoIncluye(convertExtrasToHTML(newIds, normalizedExtras, false));
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <AditamentosCustom
                                                customAditamentos={customAditamentos}
                                                onAddCustomAditamento={handleAddCustomAditamento}
                                                onRemoveCustomAditamento={handleRemoveCustomAditamento}
                                                onToggleInclusion={handleToggleCustomAditamento}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </TabPanel>
                            {/* <TabPanel value={value} index={2}>
                                <ControllerEditor onValue={onNoIncluyeValue} content={noIncluye} />
                            </TabPanel> */}
                        </Grid>
                    </DialogContent>
                    
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </ModalBase>
        </div>
    )
}

export default FProveedoresTerrestres;